import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { GetGlobalDropdown } from "../../Apis/AuthApiServices";
import {
  loadingGlobalDropdown,
  setGlobalDropdown,
} from "../Slice/GlobalDropdownSlice";

function* onLoadGlobalDropdownAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  try {
    const result: AxiosResponse = yield GetGlobalDropdown(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setGlobalDropdown({
          DropdownLists: result?.data?.response[0],
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setGlobalDropdown({
          DropdownLists: [],
          error: true,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setGlobalDropdown({
        DropdownLists: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadGlobalDropdown() {
  yield takeLatest(loadingGlobalDropdown.type, onLoadGlobalDropdownAsync);
}

const GlobalDropdownSaga = [fork(onLoadGlobalDropdown)];
export default GlobalDropdownSaga;
